/* eslint-disable max-len */
import React from 'react'
import { createIcon } from '@chakra-ui/icon'

const ExternalStorageGraphic = createIcon({
  path: (
    <g transform="translate(-539 -472.539)">
      <circle
        cx="50.5"
        cy="50.5"
        r="50.5"
        transform="translate(539 472.539)"
        fill="#e5edfb"
        opacity="0.5"
      />
      <g transform="translate(-3 -2.811)">
        <path
          d="m3335.477 2347.377-11.137.863-10.9 2.51-8.235 3.922-3.373 3.137-1.1 4.706v14.585l2.039 3.294 2.431 2.274-2.431 2.353-2.039 3.843v15.451l1.1 2.98 3.373 3.215 6.588 3.373 7.843 2.274 9.8 1.49h11.686l11.529-1.02 8.941-2.2 6.2-3.137 3.607-3.372 1.333-2.9.47-6.039-.47-9.333-.784-3.215-2.2-2.588-1.333-.862 2.98-3.765 1.8-3.843-.47-6.51v-7.686l-.784-3.764-3.529-3.059-5.333-2.823-8.392-2.117-14.431-2.039z"
          transform="translate(-2744.443 -1865.406)"
          fill="#d6ebff"
        />
        <g transform="translate(555 480.695)">
          <path
            d="M91.968 52.74a20.647 20.647 0 0 1-2.646 1.709c2.973 1.739 4.831 3.775 4.831 6.035 0 7.12-18.119 12.084-34.4 12.084s-34.4-4.965-34.4-12.01c0-2.259 1.828-4.3 4.831-6.035a20.647 20.647 0 0 1-2.646-1.709C24.263 55 22.39 57.586 22.39 60.558v14.567c0 8.443 16.35 15.057 37.368 15.057s37.368-6.614 37.368-15.057V60.558c0-2.972-1.888-5.558-5.158-7.818zm-32.21 34.47c-16.261 0-34.4-4.965-34.4-12.084V66.5c5.648 5.381 18.744 9.067 34.4 9.067s28.747-3.716 34.4-9.067v8.621c-.005 7.124-18.139 12.089-34.4 12.089z"
            transform="translate(-22.39 -17.066)"
            fill="#2c93fa"
          />
          <path
            d="M59.758 28.74C38.8 28.74 22.39 35.354 22.39 43.8v14.638c0 8.443 16.35 15.057 37.368 15.057s37.368-6.614 37.368-15.057V43.8c0-8.446-16.426-15.06-37.368-15.06zm0 2.973c16.261 0 34.4 4.965 34.4 12.084s-18.134 12.084-34.4 12.084-34.4-4.965-34.4-12.084 18.124-12.084 34.4-12.084zm0 38.81c-16.261 0-34.4-4.965-34.4-12.084v-8.652c5.648 5.381 18.744 9.067 34.4 9.067s28.747-3.686 34.4-9.067v8.651c-.005 7.12-18.139 12.085-34.4 12.085z"
            transform="translate(-22.39 -28.74)"
            fill="#2c93fa"
          />
        </g>
      </g>
    </g>
  ),
  viewBox: '0 0 101 101',
})

export default ExternalStorageGraphic
